/* NeuraTouch pack-variant bridge
 * Keep genpen-1 ($39.99) selected for quantity-break DISPLAY math.
 * On add-to-cart only: map Buy 1/2/3 -> genpen-1/2/3 with quantity 1.
 */
(function () {
  var PACK = { "1": 53591033119085, "2": 53591047700845, "3": 53591047733613 };
  var BASE = PACK["1"];

  function hidePackPills() {
    document
      .querySelectorAll(
        ".product-form__input--pills, variant-selects, variant-radios, .sticky-atc__variant-select, .sticky-atc__picker--combined, secondary-variant-select, .sticky-atc .product-form__input"
      )
      .forEach(function (el) {
        if (el.closest && el.closest(".quantity-breaks")) return;
        el.style.setProperty("display", "none", "important");
      });
    document
      .querySelectorAll(
        ".quantity-breaks .product-form__input, .quantity-breaks variant-selects, .quantity-breaks .variant-selects"
      )
      .forEach(function (el) {
        el.style.setProperty("display", "none", "important");
      });
  }

  function setVariantId(id, dispatch) {
    document
      .querySelectorAll(
        'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
      )
      .forEach(function (el) {
        el.value = String(id);
        if (dispatch) {
          el.dispatchEvent(new Event("change", { bubbles: true }));
          el.dispatchEvent(new Event("input", { bubbles: true }));
        }
      });
  }

  function setCartQuantity(qty) {
    document
      .querySelectorAll('form[action*="/cart/add"] input[name="quantity"]')
      .forEach(function (el) {
        // Keep quantity-break radios alone; only force ATC form qty fields
        if (el.closest && el.closest(".quantity-breaks")) return;
        if (el.type === "radio") return;
        el.value = String(qty);
      });
    var f = document.querySelector('form[action*="/cart/add"]');
    if (!f) return;
    var h = f.querySelector('input[name="quantity"][data-neuratouch-pack]');
    if (!h) {
      h = document.createElement("input");
      h.type = "hidden";
      h.name = "quantity";
      h.setAttribute("data-neuratouch-pack", "1");
      f.appendChild(h);
    }
    h.value = String(qty);
  }

  /** Keep base unit variant so Shrine qty-break cards price from $39.99 */
  function keepDisplayBase() {
    setVariantId(BASE, true);
  }

  function selectedQty() {
    var checked = document.querySelector(
      '.quantity-breaks input[type="radio"]:checked, .quantity-breaks input[name="quantity"]:checked'
    );
    if (checked) {
      var dq = checked.getAttribute("data-quantity") || checked.value;
      var n = parseInt(dq, 10);
      if (n === 1 || n === 2 || n === 3) return n;
      // value may be option index string "3"
      if (String(dq) === "3" || checked.id && /quantity3/i.test(checked.id)) return 3;
      if (String(dq) === "2" || checked.id && /quantity2/i.test(checked.id)) return 2;
      if (String(dq) === "1" || checked.id && /quantity1/i.test(checked.id)) return 1;
    }
    var sel = document.querySelector(
      ".quantity-breaks .quantity-break.is-selected, .quantity-breaks [aria-checked='true']"
    );
    if (sel) {
      var d = sel.getAttribute("data-quantity");
      if (d) return parseInt(d, 10) || 3;
    }
    return 3;
  }

  function applyPackForCart(q) {
    var id = PACK[String(q)] || BASE;
    setVariantId(id, false);
    setCartQuantity(1);
  }

  document.addEventListener(
    "change",
    function (e) {
      var t = e.target;
      if (!t) return;
      if (
        t.closest &&
        t.closest(".quantity-breaks") &&
        (t.matches('input[type="radio"]') || t.hasAttribute("data-quantity"))
      ) {
        // Re-anchor display math to $39.99 base after theme variant updates
        setTimeout(keepDisplayBase, 0);
        setTimeout(keepDisplayBase, 50);
      }
    },
    true
  );

  document.addEventListener(
    "click",
    function (e) {
      var label =
        e.target &&
        e.target.closest &&
        e.target.closest(
          '.quantity-breaks label, .quantity-break, .quantity-breaks [role="radio"]'
        );
      if (label) {
        setTimeout(keepDisplayBase, 0);
        setTimeout(keepDisplayBase, 40);
        setTimeout(hidePackPills, 40);
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
      applyPackForCart(selectedQty());
    },
    true
  );

  // Fetch /cart/add intercept (AJAX ATC)
  if (window.fetch) {
    var _fetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : input && input.url;
        if (url && String(url).indexOf("/cart/add") !== -1) {
          var q = selectedQty();
          var id = PACK[String(q)] || BASE;
          if (init && init.body && typeof init.body === "string") {
            var params = new URLSearchParams(init.body);
            params.set("id", String(id));
            params.set("quantity", "1");
            init = Object.assign({}, init, { body: params.toString() });
          } else if (init && init.body instanceof FormData) {
            init.body.set("id", String(id));
            init.body.set("quantity", "1");
          }
        }
      } catch (err) {}
      return _fetch(input, init);
    };
  }

  function boot() {
    hidePackPills();
    keepDisplayBase();
    setTimeout(function () {
      keepDisplayBase();
      hidePackPills();
    }, 100);
    setTimeout(function () {
      keepDisplayBase();
      hidePackPills();
    }, 400);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
